import CheckedList from './CheckedList';

export default CheckedList;
